export const SEARCH_PAGE_PATH = '/search'
